module.exports = "<div class=\"v-middle\" ng-hide=\"$ctrl.tableLoaded\">\n  <div class=\"spinner\" >\n    <div class=\"rect1\"></div>\n    <div class=\"rect2\"></div>\n    <div class=\"rect3\"></div>\n    <div class=\"rect4\"></div>\n    <div class=\"rect5\"></div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/loadingIndicator/loadingIndicator.html
// module id = 509
// module chunks = 0